"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import WorkScopeStatusSelect from "../work-scope-status-select"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { 
    workScopeStatusOptions, 
    whatTypeOfFlooringOptions 
} from "../../constants/options"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const BASE_FIELD_NAME = "home.flooringInstallInfo"


function HomeFlooringInstallForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillFlooringInstallOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillFlooringInstallOn` })
    
    // Watch status field and claimed by field
    const flooringInstall = useWatch({ control, name: `${BASE_FIELD_NAME}.flooringInstall` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillFlooringInstall = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillFlooringInstall` })
    const goodwillFlooringInstallClaimedBy = useWatch({
        control,
        name: `${BASE_FIELD_NAME}.goodwillFlooringInstallClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: flooringInstall,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillFlooringInstall,
        claimedBy: goodwillFlooringInstallClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillFlooringInstallClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillFlooringInstallOn,
    })
    return (
        <HomeDetailsWrapperAccordion 
            heading="Flooring Install"
            wrapperClassName="xl:grid-cols-2"
        >
            <WorkScopeStatusSelect workScopeSlug="flooring-install"
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Flooring Install" toggleName={`${BASE_FIELD_NAME}.goodwillFlooringInstallOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.flooringInstall`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillFlooringInstallOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Flooring Install Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillFlooringInstall`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Flooring Install Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillFlooringInstallClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <FormSelectInput
                inputGroupProps={{
                    label: "What is the subfloor material?"
                }}
                options={whatTypeOfFlooringOptions}
                name={`${BASE_FIELD_NAME}.subfloorType`}
                control={control}
            />
            <FormTextInput
                inputGroupProps={{
                    label: "Total square feet of flooring needed",
                }}
                placeholder="Total square feet of flooring needed"
                name={`${BASE_FIELD_NAME}.flooringSquareFeet`}
                type="number"
                control={control}
            />
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Add any other detail you can about the flooring installation needs",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={4}
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeFlooringInstallForm
